import { NotificacionesService } from './../../../services/notificaciones.service';
import { ChatService } from '../../../services/chat.service';
import { UserService } from '../../../services/user.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { ColegiosService } from 'src/app/services/colegios.service';
import { NumeroalertasService } from 'src/app/admin/services/numeroalertas.service';
import { AlertasService } from 'src/app/services/alertas.service';

@Component({
  selector: 'app-hilo',
  templateUrl: './hilo.component.html',
  styleUrls: ['./hilo.component.css'],
})
export class HiloComponent implements OnInit, OnDestroy {
  mainuserid: string;
  searchValue = '';
  results: any;
  chatmessage = '';
  receiverid: string;
  chats = [];
  chatmessages = [];
  datecu: Date;
  elotrousaurio: any;
  urluid: string;
  /*nuevo */
  grupodechats = [];
  chatorimessa = [];
  userchat: any;
  chatusers = [];
  chatload = false;
  mainuseremail: any;
  usuario: any;
  cole: any;
  idSupervisor: any = '';
  obsNotificacion: any = null;
  mensajesAlmacenados = [];
  formatoChatIA: any = {};
  alerta24h: any = null;

  constructor(
    private activatedRoute: ActivatedRoute,
    private notificacionesService: NotificacionesService,
    private userService: UserService,
    private chatService: ChatService,
    private authenticationService: AuthenticationService,
    private translate: TranslateService,
    private _colegiosService: ColegiosService,
    private _numeroAlertas: NumeroalertasService,
    private _alertService: AlertasService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.urluid = params['uid'];
      this.chatService.setChatActual(this.urluid);
      const urlsplit = this.urluid.split('|');
      if (urlsplit[0] === urlsplit[1]) {
        return;
      }
      this.authenticationService.getStatus().subscribe(
        (status) => {
          this.mainuserid = status.uid;
          this.mainuseremail = status.email;
          if (urlsplit[0] != this.mainuserid) {
            this.elotrousaurio = urlsplit[0];
          } else {
            this.elotrousaurio = urlsplit[1];
          }
          if (this.elotrousaurio) {
            this.userService
              .getUserById(this.elotrousaurio)
              .subscribe((userchat) => {
                this.userchat = userchat[0].payload.doc.data();
                if (!this.chatusers[this.userchat.uid]) {
                  this.chatusers[this.userchat.uid] =
                    userchat[0].payload.doc.data();
                }
              });
            this.obsNotificacion = this.notificacionesService
              .getNotificacionesMensajesDeEmisor(
                this.mainuserid,
                this.elotrousaurio
              )
              .subscribe((mensajes) => {
                mensajes.forEach((mensaje) => {
                  let id = mensaje.payload.doc.id;
                  this.notificacionesService.removeNotificacion(id).then();
                });
              });
          }

          let suscription = this.userService
            .getUserById(this.mainuserid)
            .subscribe((user) => {
              this.usuario = user[0].payload.doc.data();

              let colegioSus = this._colegiosService
                .getColegioByIdNow(this.usuario.colegios[0])
                .subscribe((colegio) => {
                  this.cole = colegio.data();

                  suscription.unsubscribe();
                  this.userService
                    .getSupervisor(colegio.id)
                    .subscribe((usuario) => {
                      if (!usuario.empty) {
                        var usua = usuario.docs[0].data();
                        this.idSupervisor = usua['uid'];
                      }
                      colegioSus.unsubscribe();
                    });
                });
            });
          this.buscarSiExisteAlerta();
          this.cargarmensajes();
        },
        (error) => {
          console.log(error);
        }
      );
    });
  }

  ngOnDestroy(): void {
    if (this.obsNotificacion != null) {
      this.obsNotificacion.unsubscribe();
    }
  }

  buscarSiExisteAlerta() {
    const members = {
      members: [
        { uid: this.mainuserid, join: true },
        { uid: this.elotrousaurio, join: true },
      ],
    };
    const ids = [this.mainuserid, this.elotrousaurio].sort();
    const chatid = ids.join('|');
    console.log('buscando alerta', chatid);
    this._alertService.getAlertaByIdChat(chatid).subscribe((alerta: any) => {
      if (alerta.length > 0) {
        const alertaDoc = alerta[0].payload.doc;
        const alertaData = alertaDoc.data();
        const fechaAlerta = alertaData.fechaAlerta.toDate();
        const ahora = new Date();
        const diferenciaHoras =
          (ahora.getTime() - fechaAlerta.getTime()) / (1000 * 60 * 60);
        if (diferenciaHoras < 12) {
          this.alerta24h = alertaDoc;
        }
      }
    });
  }

  async sendmessage() {
    let len = this.translate.getDefaultLang();

    if (this.chatmessage != '') {
      this.datecu = new Date();
      const message: any = {
        sender: this.mainuserid,
        receiver: this.elotrousaurio,
        message: this.chatmessage,
        fecha: this.datecu,
        verlo: [this.mainuserid, this.elotrousaurio],
        nuevo: true,
      };
      this.chatmessage = '';
      const members = {
        members: [
          { uid: this.mainuserid, join: true },
          { uid: this.elotrousaurio, join: true },
        ],
      };
      const ids = [this.mainuserid, this.elotrousaurio].sort();
      const chatid = ids.join('|');
      this.chatService
        .sendmessage(chatid, message, members)
        .then(async () => {
          this.cargarmensajes();
          // Mantiene la llamada original, pero ahora usa OpenAI para la toxicidad:
          // this.analisis(message);
          await this.analisisChat(message);

          var notification = {
            user: this.elotrousaurio,
            texto: '🗨️ ' + message.message,
            url: '/dashboard/mensajes/chat/' + chatid,
            verlo: this.elotrousaurio,
            fecha: new Date(),
            emisor: this.mainuserid,
            mensaje: true,
          };

          this.notificacionesService.createdNotificacion(notification);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  /**
   * ============
   *   OPENAI
   * ============
   */

  private async callOpenAI(body: any): Promise<any> {
    const resp = await fetch(
      'https://us-central1-colegia-education-demo.cloudfunctions.net/app/callOpenAI',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      }
    );

    if (!resp.ok) {
      const text = await resp.text();
      throw new Error(`OpenAI error ${resp.status}: ${text}`);
    }

    return resp.json();
  }

  /**
   * Analiza un único mensaje con OpenAI y devuelve true si es tóxico.
   * Mantiene la firma/uso original.
   */
  async analisis(message: any) {
    try {
      const body = {
        model: 'gpt-4o-mini',
        temperature: 0,
        messages: [
          {
            role: 'system',
            content:
              'Eres un clasificador estricto de toxicidad. Responde SOLO un JSON válido con el formato {"toxic": true|false, "labels": string[]}. La toxicidad incluye insultos, acoso, amenazas, discurso de odio o lenguaje sexual explícito inapropiado.',
          },
          {
            role: 'user',
            content: `Clasifica este mensaje como tóxico o no tóxico.\n\nMensaje: """${message.message}"""`,
          },
        ],
        response_format: { type: 'json_object' },
      };

      const data = await this.callOpenAI(body);
      const raw = data?.choices?.[0]?.message?.content || '{}';
      const parsed = JSON.parse(raw);
      const esToxico = !!parsed.toxic;

      if (esToxico) {
        this._numeroAlertas.getNumber().subscribe((alerta) => {
          alerta.forEach((alertaDato) => {
            var alertita: any = alertaDato.data();

            var number: number = alertita.numero;
            this._numeroAlertas.editNumber();
            var alertaObj = {
              avatarColegio: this.cole?.avatar,
              estado: 'pendiente',
              fechaAlerta: message.fecha,
              idAlerta: number,
              idColegio: this.cole?.nombre,
              idSupervisor: this.idSupervisor,
              idUsuario: message.sender,
              mensaje:
                'Posible amenaza con bullying (detectada por clasificador IA)',
              mostrarSupervisor: true,
              avatarAlumno: this.usuario?.avatar,
              reportada: true,
              nombre: this.usuario?.usuario,
            };

            console.log(alertaObj);

            this._alertService
              .createdAlerta(alertaObj)
              .then(() => console.log('Alerta creada'));
          });
        });
      }
    } catch (e) {
      console.error('Error en analisis (OpenAI):', e);
      // En error no interrumpimos el flujo.
    }
  }

  /**
   * Analiza la ventana de 12h del chat con OpenAI y emite alerta agregada
   * respetando la lógica de severidad/creación/edición original.
   */
  async analisisChat(message: any) {
    try {
      const ids = [this.mainuserid, this.elotrousaurio].sort();
      const chatid = ids.join('|');

      const dataTrans = this.formatoChatIA;

      const body = {
        model: 'gpt-4o-mini',
        temperature: 0,
        messages: [
          {
            role: 'system',
            content:
              'Eres un analista de conversaciones encargado de detectar toxicidad y resumir el contexto. Devuelve SOLO un JSON válido con el formato: {"total_messages": number, "total_toxic_messages": number, "global_summary": string}. Considera como tóxico: insultos, acoso, amenazas, discurso de odio, doxxing, presión sexual explícita inapropiada. No cuentes mensajes triviales como tóxicos.',
          },
          {
            role: 'user',
            content:
              `Analiza los mensajes de las últimas 12h y devuelve el JSON solicitado. ` +
              `Los datos vienen en este formato:\n\n` +
              JSON.stringify(
                {
                  chat_id: dataTrans?.chat_id,
                  messages: (dataTrans?.messages || []).map((m: any) => ({
                    sender: m.sender,
                    content: m.content,
                    timestamp: m.timestamp,
                  })),
                },
                null,
                2
              ),
          },
        ],
        response_format: { type: 'json_object' },
      };

      const data = await this.callOpenAI(body);
      const raw = data?.choices?.[0]?.message?.content || '{}';
      const parsed = JSON.parse(raw);

      const total = Number(parsed.total_messages) || 0;
      const toxicos = Number(parsed.total_toxic_messages) || 0;
      const global_summary =
        typeof parsed.global_summary === 'string'
          ? parsed.global_summary
          : 'Resumen no disponible';

      let severidadMaxima = '';
      if (total >= 2) {
        const porcentaje = (toxicos / total) * 100;
        if (porcentaje >= 75) {
          severidadMaxima = 'alta';
        } else if (porcentaje >= 50) {
          severidadMaxima = 'media';
        } else if (porcentaje >= 20) {
          severidadMaxima = 'baja';
        }
      }

      if (severidadMaxima) {
        let tipoMensaje = '';
        switch (severidadMaxima) {
          case 'alta':
            tipoMensaje = '🚨 Amenaza crítica detectada';
            break;
          case 'media':
            tipoMensaje = '⚠️ Advertencia seria detectada';
            break;
          case 'baja':
          default:
            tipoMensaje = '🟡 Comportamiento inapropiado';
            break;
        }

        const mensajeAlerta = `${tipoMensaje}: ${global_summary}`;

        if (this.alerta24h != null) {
          const alerta = {
            estado: 'pendiente',
            fechaAlerta: message.fecha,
            idAlerta: this.alerta24h.data().idAlerta,
            idChat: this.alerta24h.data().idChat,
            idColegio: this.alerta24h.data().idColegio,
            idSupervisor: this.alerta24h.data().idSupervisor,
            idUsuario: this.alerta24h.data().idUsuario,
            mensaje: mensajeAlerta,
            mostrarSupervisor: true,
            reportada: true,
            nombre: this.alerta24h.data().nombre,
            resumen: global_summary,
            severidad: severidadMaxima,
          };
          this._alertService.editAlerta(this.alerta24h.id, alerta);
        } else {
          this._numeroAlertas.getNumber().subscribe((alerta) => {
            alerta.forEach((alertaDato) => {
              const alertita: any = alertaDato.data();
              const number: number = alertita.numero;
              this._numeroAlertas.editNumber();

              const nuevaAlerta = {
                estado: 'pendiente',
                fechaAlerta: message.fecha,
                idAlerta: number,
                idChat: chatid,
                idColegio: this.cole?.nombre,
                idSupervisor: this.idSupervisor,
                idUsuario: message.sender,
                mensaje: mensajeAlerta,
                mostrarSupervisor: true,
                reportada: true,
                nombre: this.usuario?.usuario,
                resumen: global_summary,
                severidad: severidadMaxima,
              };

              console.log(nuevaAlerta);
              this._alertService
                .createdAlerta(nuevaAlerta)
                .then(() => console.log('Alerta creada'));
            });
          });
        }
      }
    } catch (e) {
      console.error('Error en analisisChat (OpenAI):', e);
    }
  }

  cargarmensajes() {
    if (!this.grupodechats[this.urluid]) {
      this.chatService
        .getMessages(this.urluid, this.mainuserid)
        .subscribe((message) => {
          const messagechatid = [
            message[0]?.payload.doc.data().sender,
            message[0]?.payload.doc.data().receiver,
          ].sort();
          const themeschaid = messagechatid.join('|');

          this.grupodechats[themeschaid] = message;
          console.log('mensaje', message);
          this.mensajesAlmacenados = [];
          this.mensajesAlmacenados = message;
          this.formatoChatIA = this.darFormatoMensajesIA12h();
          console.log(this.formatoChatIA);

          if (
            this.mainuserid !==
            this.grupodechats[this.urluid][0]?.payload.doc.data().receiver
          ) {
            this.elotrousaurio =
              this.grupodechats[this.urluid][0]?.payload.doc.data().receiver;
          } else {
            this.elotrousaurio =
              this.grupodechats[this.urluid][0]?.payload.doc.data().sender;
          }

          this.userService
            .getUserById(
              this.grupodechats[this.urluid][0]?.payload.doc.data().receiver
            )
            .subscribe((userchat) => {
              this.userchat = userchat[0]?.payload.doc.data();
              if (!this.chatusers[this.userchat.uid]) {
                this.chatusers[this.userchat.uid] =
                  userchat[0]?.payload.doc.data();
              }
            });

          this.userService
            .getUserById(
              this.grupodechats[this.urluid][0]?.payload.doc.data().sender
            )
            .subscribe((userchat) => {
              this.userchat = userchat[0]?.payload.doc.data();
              if (!this.chatusers[this.userchat.uid]) {
                this.chatusers[this.userchat.uid] =
                  userchat[0]?.payload.doc.data();
              }
            });

          this.chatload = true;
        });
    } else {
      if (
        this.mainuserid !==
        this.grupodechats[this.urluid][0]?.payload.doc.data().receiver
      ) {
        this.elotrousaurio =
          this.grupodechats[this.urluid][0]?.payload.doc.data().receiver;
      } else {
        this.elotrousaurio =
          this.grupodechats[this.urluid][0]?.payload.doc.data().sender;
      }
    }
  }

  scrolltobottom() {
    const objDiv = document.getElementById('themessagesbox') as HTMLElement;
    if (objDiv) {
      objDiv.scrollTop = objDiv.scrollHeight + 1000;
    }
  }

  darFormatoMensajesIA() {
    const format = {
      chat_id: this.urluid,
      messages: [] as any[],
    };
    this.mensajesAlmacenados.forEach((mensaje) => {
      var datos = mensaje.payload.doc?.data();

      const milisegundos =
        datos.fecha.seconds * 1000 + datos.fecha.nanoseconds / 1000000;

      const fecha = new Date(milisegundos);

      format.messages.push({
        sender: datos.sender,
        content: datos.message,
        timestamp: fecha,
      });
    });
    return format;
  }

  darFormatoMensajesIA12h() {
    const format = {
      chat_id: this.urluid,
      messages: [] as any[],
    };

    const ahora: any = new Date();
    const milisegundos12Horas = 12 * 60 * 60 * 1000;

    this.mensajesAlmacenados.forEach((mensaje) => {
      var datos = mensaje.payload.doc?.data();

      const milisegundos =
        datos.fecha.seconds * 1000 + datos.fecha.nanoseconds / 1000000;

      const fecha: any = new Date(milisegundos);

      if (ahora - fecha <= milisegundos12Horas) {
        format.messages.push({
          sender: datos.sender,
          content: datos.message,
          timestamp: fecha,
        });
      }
    });

    return format;
  }

  addMessageIA(message) {
    let fecha: Date;
    if (
      message?.fecha?.seconds != null &&
      message?.fecha?.nanoseconds != null
    ) {
      const ms =
        message.fecha.seconds * 1000 + message.fecha.nanoseconds / 1000000;
      fecha = new Date(ms);
    } else {
      fecha = new Date(message.fecha ?? Date.now());
    }

    this.formatoChatIA.messages.push({
      sender: message.sender,
      content: message.message,
      timestamp: fecha,
    });
    return this.formatoChatIA;
  }
}
